<?php

$variables = array() ;
$variables['application_slug'] = 'videointerviews' ;
$variables['description'] = 'Video Interviews' ;
$variables['subdomain'] = 'www' ;
$variables['webclientsubdomain'] = 'www' ;
$variables['server_subdomain'] = 'api' ;
$variables['admin_subdomain'] = 'admin' ;
$variables['crm_subdomain'] = 'crm' ;
$variables['domain'] = 'videointerviews.cloud' ;
$variables['friendly_app_slug'] = 'VideoInterviews' ;
$variables['desktop_app_slug'] = $variables['friendly_app_slug'] ;
$variables['random_port_suffix'] = '39' ;
$variables['infra_type'] = 'cloud' ;

$request_host = '' ;
if (isset($_SERVER['HTTP_X_FORWARDED_HOST']) && $_SERVER['HTTP_X_FORWARDED_HOST'] !== '') {
    $request_host = $_SERVER['HTTP_X_FORWARDED_HOST'] ;
} else if (isset($_SERVER['HTTP_HOST']) && $_SERVER['HTTP_HOST'] !== '') {
    $request_host = $_SERVER['HTTP_HOST'] ;
}

if ($request_host !== '' && strpos($request_host, ':') !== false) {
    $request_host = explode(':', $request_host)[0] ;
}

$is_staging_host = false ;
if ($request_host !== '') {
    $is_staging_host = (strpos($request_host, '.staging.') !== false) || (strpos($request_host, 'staging.') === 0) ;
}

if (isset($params['backendenv'])) {
    $variables['backendenv'] = $params['backendenv'] ;
    if (in_array($params['backendenv'], array('local', 'devcloud'))) {
        $variables['custom_branch'] = 'development' ;
    }
} else {
    $params['backendenv'] = $is_staging_host ? 'staging' : 'prod' ;
    $variables['backendenv'] = $params['backendenv'] ;
}

if ($variables['backendenv'] === 'staging') {
    $variables['subdomain'] = 'www.staging' ;
    $variables['webclientsubdomain'] = 'www.staging' ;
    $variables['server_subdomain'] = 'api.staging' ;
}

$variables['api_base_url'] = 'https://' . $variables['server_subdomain'] . '.' . $variables['domain'] ;

if (defined('ISOPHP_EXECUTION_ENVIRONMENT') && ISOPHP_EXECUTION_ENVIRONMENT == 'UNITER') {
    \ISOPHP\js_core::$console->log('before loop') ;
    \ISOPHP\js_core::$console->log($variables) ;
    $temp_config = \Model\Configuration::$config ;
    foreach ($variables as $this_key => $this_value) {
        \ISOPHP\js_core::$console->log('this key is ' . $this_key) ;
        \ISOPHP\js_core::$console->log('this value is ' . $this_value) ;
        \ISOPHP\js_core::$console->log('config is ', $temp_config) ;
        $temp_config[$this_key] = $this_value ;
    }
    \Model\Configuration::$config = $temp_config ;
    \ISOPHP\js_core::$console->log('registry dump') ;
    \ISOPHP\js_core::$console->log(\Model\Configuration::$config) ;
}



// WEBPACK FOOTER //
// core/default.php